import React, { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import noImage from '@assets/images/placeholder/article-placeholder.jpg'
import Image from 'next/image'

function ResponsiveImg({ src = '', srcSet = [], alt, className, errorSrc, ...rest }) {
  const [url, setUrl] = useState(src)
  const wasError = useRef(false)
  const id = src?.split('/').pop().split('_')[0]

  useEffect(() => {
    // if (isLoadOnInteraction) {
    //   if (isLoaded) setUrl(src)
    //   else setUrl(noImage)
    // } else
    // if (!wasError.current) {
    setUrl(src)
    // if (srcSet?.length) console.log(src)
    // }
  }, [src])

  function handleError(e) {
    const { target } = e
    const index = srcSet?.findIndex((e) => e?.URL === target?.currentSrc)
    if (index !== -1) {
      document.getElementById(`${id}-${index}`)?.remove()
    } else if (errorSrc && ((typeof errorSrc === 'object' && target?.currentSrc !== errorSrc.src) || target?.currentSrc !== errorSrc)) {
      setUrl(errorSrc)
    } else setUrl(noImage)
  }

  if (srcSet?.length) {
    return (
      <picture suppressHydrationWarning>
        {srcSet?.map((e, i) => (
          <source id={`${id}-${i}`} key={`${i}-${e?.media}`} media={e?.media} srcSet={e?.URL} />
        ))}
        <Image
          unoptimized
          alt={alt}
          src={url}
          className={`d-block w-100 ${rest?.fill ? '' : 'h-auto'} ${className || ''}`}
          onError={(e) => {
            wasError.current = true
            handleError(e)
          }}
          {...rest}
        />
      </picture>
    )
  } else {
    return (
      <Image
        unoptimized
        alt={alt}
        src={url}
        className={`d-block w-100 ${rest?.fill ? '' : 'h-auto'} ${className || ''}`}
        onError={(e) => {
          wasError.current = true
          handleError(e)
        }}
        {...rest}
      />
    )
  }
}
export default React.memo(ResponsiveImg)
ResponsiveImg.propTypes = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
  className: PropTypes.string,
  srcSet: PropTypes.array,
  isLoadOnInteraction: PropTypes.bool,
  errorSrc: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  onError: PropTypes.func
}
